import { useQuery } from '@tanstack/react-query'
import { Outlet, useParams } from 'react-router-dom'
import { getOwnerEvent } from '../api/owner'
import { isNotFound } from '../api/client'
import { BrokenLink } from '../components/BrokenLink'
import { LoadingScreen } from '../components/LoadingScreen'
import { Titled } from '../components/Titled'
import { EventRail } from './components/EventRail'
import { EventContext } from './eventContext'

/**
 * De schil om alle beheerschermen van één event: de zijnavigatie op desktop, en
 * op mobiel niets — daar is de "Beheren"-lijst op de eventpagina de navigatie.
 */
export function EventLayout() {
  const { eventId = '' } = useParams()

  const subject = useQuery({
    queryKey: ['owner', 'event', eventId],
    queryFn: () => getOwnerEvent(eventId),
    retry: (count, error) => !isNotFound(error) && count < 2,
  })

  // Zonder eigen titel blijft hier staan wat het vorige scherm zette, en dan
  // zegt je tabblad "Gasten - Confetti" terwijl er "dit event bestaat niet" op
  // staat. De schermen hieronder zetten hem zelf; deze twee komen daar nooit
  // aan toe, want dan is er geen event om er een te tonen.
  if (isNotFound(subject.error)) {
    return (
      <Titled title={null}>
        <BrokenLink
          title="Dit event bestaat niet"
          detail="Misschien is het verwijderd, of hoort het bij een ander account."
        />
      </Titled>
    )
  }

  if (subject.isPending || !subject.data) {
    return (
      <Titled title={null}>
        <LoadingScreen label="Event ophalen…" />
      </Titled>
    )
  }

  return (
    <EventContext.Provider
      value={{ subject: subject.data, refresh: async () => void (await subject.refetch()) }}
    >
      <div className="flex min-h-full lg:h-full">
        <EventRail subject={subject.data} />

        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <Outlet />
        </div>
      </div>
    </EventContext.Provider>
  )
}
